"use client"

import styles from "./styles.module.scss";
import { motion } from "framer-motion";
import { header_submenu_animation } from "../../animation";
import { randomString } from "../../core-nextv3/util/util";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { BsChevronRight } from "react-icons/bs";
import { ClassCurrentMenu } from "../../core-nextv3/menu/menu.api";
import CustomLink from "@/component-nextv3/CustomLink";

export const MenuTypeMobile = ({ menu, closeMenu }: any) => 
{        
    const getMenu = (item: any) => 
    {
        switch (item?.type?.value) 
        {
            case "path":
                return (
                    <>
                        <CustomLink href={`${item.link}`} 
                            className={(item.highlight ? styles.highlight : "") + " " + (item.bold ? styles.bold : "") + " " + styles[ClassCurrentMenu(item)]}                    
                            onClick={() => 
                            {
                                closeMenu() 
                            }}
                            key={randomString(8)}>
                            {item?.name}
                        </CustomLink>
                        {item?._children?.length > 0 && (
                            <motion.ul
                                className={styles.subMenuGrid}
                                variants={header_submenu_animation}
                            >
                                {item?._children?.map(
                                    (child: any) => (
                                        child.status && getMenu(child)
                                    )
                                )}                    
                            </motion.ul>
                        )}
                    </>
                );
            case "category":
                return (
                    <>
                        <CustomLink
                            href={`/categoria/${item?.category?.slug}/`}
                            onClick={() => 
                            {
                                closeMenu() 
                            }}
                            className={(item.highlight ? styles.highlight : "") + " " + (item.bold ? styles.bold : "") + " " + styles[ClassCurrentMenu(item)]}                  
                            key={randomString(8)}
                        >
                            {item?.name}
                        </CustomLink>

                        {item?.category?._children?.length > 0 && (
                            <motion.ul
                                className={styles.subMenuGrid}
                                variants={header_submenu_animation}
                            >
                                <CustomLink onClick={() => 
                                {
                                    closeMenu() 
                                }} 
                                href={`/categoria/${item?.category?.slug}/`}>
                        Ver Todos
                                </CustomLink>
                                {item?.category?._children?.map(
                                    (child: any) => (
                                        child.status && getMenu(child)
                                    )
                                )}
                            </motion.ul>
                        )}
                    </>
                );

            case "collection":
                return (
                    <CustomLink
                        href={`/colecao/${item?.collection?.slug}/1/`}
                        className={(item.highlight ? styles.highlight : "") + " " + (item.bold ? styles.bold : "") + " " + styles[ClassCurrentMenu(item)]}
                        onClick={() => 
                        {
                            closeMenu() 
                        }}                
                        key={randomString(8)}
                    >
                        {item?.name}
                    </CustomLink>
                );
            default:
                return null;
        }
    };

    return (
        <div className={styles.menuTypeMobile}>
            {menu?.map(
                (item: any, index:number) =>
                    item.status && (
                        <div className={styles.navigation} key={index}>
                            {item?._children?.length > 0 ? (
                                <Accordion disableGutters className={styles.accordion}>
                                    <AccordionSummary expandIcon={<BsChevronRight />} className={styles[ClassCurrentMenu(item)]}>
                                        {item?.name}
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className={styles.subMenuChildren}>
                                            {item?._children?.map((child: any, index:number) => (
                                                child.status && <p
                                                    key={index}
                                                >
                                                    {getMenu(child)}
                                                </p>
                                            ))}

                                            <p><CustomLink onClick={() => 
                                            {
                                                closeMenu() 
                                            }} className={styles.fixed} href={`${item.link}`}>Ver Todos</CustomLink></p>

                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            ) : (
                                item.status && getMenu(item)
                            ) }
                        </div>
                    )
            )}
        </div>
    );
};
